// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__0n6sz","content":"Footer_content__rHdm+","copyright":"Footer_copyright__AoIeD","links":"Footer_links__lwE-y","social":"Footer_social__nn76f"};